
import { Form } from "react-bootstrap"
import Button from 'react-bootstrap/Button';
import Collapse from 'react-bootstrap/Collapse';
import { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from 'react-bootstrap/Container';
import Table from "react-bootstrap/Table";
import { formatDate } from "../CustomDateTools";
import { displayTenementHolder } from "../tenements/TenementOverlay";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useMap } from "@vis.gl/react-maplibre";
import * as turf from "@turf/turf";
import { db } from '../../firebase/firebase';
import { collection, getDocs, doc, getDoc, setDoc, deleteDoc } from 'firebase/firestore';
import { v4 as uuidv4 } from 'uuid';
import { faQuestionCircle, faMinus, faPlus, faCircle } from '@fortawesome/free-solid-svg-icons';

import {
    useAuth

} from '../../contexts/authContext';
import { Generate40EPermit } from "../40E/Permit40EGenerator";
import { GraticuleTable } from "./GraticuleTable";


export function SideBar40E({
    is40ESideBarShown,
    setIs40ESideBarShown,
    tenement40E,
    setOverlayVisisbility,
    overlayVisibility,
    selectedGraticleStack,
    setSelectedGraticuleStack,
    setSideBarShown,
    setAlerts
}) {

    const emptyGeoJson = {
        "type": "FeatureCollection",
        "name": "Mining_Tenements_DMIRS_003",
        "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:EPSG::4283" } },
        "features": []
    };

    const groupBy = key => array =>
        array.reduce((objectsByKeyValue, obj) => {
            const value = obj.properties[key];
            objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
            return objectsByKeyValue;
        }, {});

    const { goldfindermap } = useMap();
    const { currentUser } = useAuth()
    const [displayName, setDisplayName] = useState(currentUser.displayName)

    const [applicant1Address, setApplicant1Address] = useState();
    const [applicant1MinersRightNo, setApplicant1MinersRightNo] = useState();
    const [applicant1PhoneNo, setApplicant1PhoneNo] = useState();
    const [vehicles, setVehicles] = useState([]);



    const [applicant2Name, setApplicant2Name] = useState()
    const [applicant2Address, setApplicant2Address] = useState();
    const [applicant2MinersRightNo, setApplicant2MinersRightNo] = useState();
    const [applicant2PhoneNo, setApplicant2PhoneNo] = useState();

    const [applicant3Name, setApplicant3Name] = useState()
    const [applicant3Address, setApplicant3Address] = useState();
    const [applicant3MinersRightNo, setApplicant3MinersRightNo] = useState();
    const [applicant3PhoneNo, setApplicant3PhoneNo] = useState();

    const [extraApplicants, setExtraApplicants] = useState([]);

    const [validated, setValidated] = useState(false);


    const reloadData = () => {
        setVehicles([]);
        const dataStorageLocation = doc(
            db,
            "user_info",
            currentUser?.uid

        );

        getDoc(dataStorageLocation).then(userData => {
            setApplicant1MinersRightNo(userData.data().minersrightno)
            setApplicant1Address(userData.data().address)
            setApplicant1PhoneNo(userData.data().phoneno)
        })

        const veichleUserStorage = collection(
            db,
            "user_info",
            currentUser?.uid,
            "vehicles"
        );

        const placemarks = getDocs(veichleUserStorage).then(vehicles => {

            const allStoredVehicles = [];
            vehicles.forEach(vehicle => {
                allStoredVehicles.push(vehicle.data());
            })


            if (allStoredVehicles.length === 0) {
                allStoredVehicles.push({
                    id: uuidv4()
                })
            }
            setVehicles(allStoredVehicles);

        })
        

    }

    useEffect(() => {
        if (tenement40E === null || tenement40E === undefined) {
            return
        } else if (is40ESideBarShown) {
            //const simpPolygon = turf.transformScale(tenement40E, 1.2);

            const turfBounds = turf.bbox(tenement40E);
            goldfindermap.fitBounds(turfBounds, {
                padding: 50,

            })

            setExtraApplicants([])
            setValidated(false)
            /*
            center: turf.center(
                    tenement40E
                ).geometry.coordinates
            */
        }
        reloadData();

    }, [tenement40E])



    useEffect(e => {
        // get the extra user data

        reloadData();

    }, [])


    const addApplicant = () => {
        setExtraApplicants([...extraApplicants, { id: uuidv4() }]);
    }

    const removeApplicant = (id) => {
        setExtraApplicants([...extraApplicants.filter(applicant =>
            applicant.id !== id
        )])
    }


    const setApplicantAddress = (id, address) => {
        setExtraApplicants([...extraApplicants.map(applicant => {
            if (applicant.id === id) {
                applicant.address = address;
            }
            return applicant;
        })])
    }

    const setApplicantFullName = (id, fullName) => {
        setExtraApplicants([...extraApplicants.map(applicant => {
            if (applicant.id === id) {
                applicant.fullName = fullName;
            }
            return applicant;
        })])
    }

    const setApplicantPhoneNumber = (id, phoneNumber) => {
        setExtraApplicants([...extraApplicants.map(applicant => {
            if (applicant.id === id) {
                applicant.phoneNumber = phoneNumber;
            }
            return applicant;
        })])
    }

    const setApplicantMinersRightNo = (id, minersRightNo) => {
        setExtraApplicants([...extraApplicants.map(applicant => {
            if (applicant.id === id) {
                applicant.minersRightNo = minersRightNo;
            }
            return applicant;
        })])
    }




    const addVehicleEntry = () => {
        setVehicles([...vehicles, { id: uuidv4() }]);
    }


    const setVehicleMake = (id, make) => {
        setVehicles([...vehicles.map(vehicle => {
            if (vehicle.id === id) {
                vehicle.make = make;
            }
            return vehicle;
        })])
    }

    const setVehicleModel = (id, model) => {
        setVehicles([...vehicles.map(vehicle => {
            if (vehicle.id === id) {
                vehicle.model = model;
            }
            return vehicle;
        })])
    }

    const setVehicleRego = (id, rego) => {
        setVehicles([...vehicles.map(vehicle => {
            if (vehicle.id === id) {
                vehicle.rego = rego;
            }
            return vehicle;
        })])
    }

    const removeVehicle = (id) => {
        setVehicles([...vehicles.filter(vehicle =>
            vehicle.id !== id
        )])
    }

    return <Container style={{ fontSize: 'medium' }}>
        <Form noValidate validated={validated} onSubmit={(e) => {
            e.preventDefault();



            const form = e.currentTarget;
            if (form.checkValidity() === false) {

                e.stopPropagation();

            } else if (selectedGraticleStack.features.length === 0) {
                setAlerts(alerts => [
                    ...alerts,
                    {
                        id: new Date().getTime(),
                        type: 'danger',
                        headline: `Please Select atleast 1 Graticule`,
                        message: 'The Section 40E permit requires atleast 1 Graticule to be selected'
                    }
                ]);
            } else {
                Generate40EPermit({
                    applicant1: { fullName: displayName, address: applicant1Address, phNumber: applicant1PhoneNo, minersRightNo: applicant1MinersRightNo },
                    applicant2: { fullName: extraApplicants[0]?.fullName, address: extraApplicants[0]?.address, phNumber: extraApplicants[0]?.phoneNumber, minersRightNo: extraApplicants[0]?.minersRightNo },
                    applicant3: { fullName: extraApplicants[1]?.fullName, address: extraApplicants[1]?.address, phNumber: extraApplicants[1]?.phoneNumber, minersRightNo: extraApplicants[1]?.minersRightNo },
                    tenement: tenement40E,
                    graticuleStack: selectedGraticleStack,
                    vehicleStack: vehicles
                });
                setSideBarShown(true)
                setIs40ESideBarShown(false);
                setSelectedGraticuleStack(emptyGeoJson)
                setOverlayVisisbility({ ...overlayVisibility, graticles: false })
            }

            setValidated(true);






        }}>
            <Row className="border-bottom border-top mb-2" style={{ paddingTop: 5, paddingBottom: 5 }}>
                <Col xs={6}>
                    <h4 >
                        Section 40E Permit Generator
                    </h4>
                </Col>
                <Col>
                    <Button type="submit" variant='success' >Generate Permit </Button>
                </Col>
                <Col>
                    <Button type="button" variant='danger' onClick={() => {
                        setIs40ESideBarShown(false);
                        // re-open the standard sidebar
                        setOverlayVisisbility({ ...overlayVisibility, graticles: false })
                        setSideBarShown(true)
                        setSelectedGraticuleStack(emptyGeoJson)
                    }} >Cancel</Button>
                </Col>
            </Row>
            <Row className="mb-1">
                <Col>Tenement ID: <strong>{tenement40E?.properties.fmt_tenid}</strong> <br />
                    Tenement Holder(s): <strong>{displayTenementHolder(tenement40E?.properties.holdername)}</strong></Col>
                <Col>
                    <h6>Graticules (Max 10) - Selected Graticular blocks on the Exploration Licence </h6>

                    <GraticuleTable graticuleStack={selectedGraticleStack}></GraticuleTable>
                </Col>
            </Row>
            <Row>
                <Col>
                    <h6>Applicant(s) Details (Max 3) - Who will be a part of the requested permit</h6>
                </Col>
            </Row>
            <Row className="mb-1">
                <Col style={{ textAlign: 'center' }}>
                    <strong>
                        Applicant 1 (You)
                    </strong>
                </Col>
            </Row>

            <Row className="mb-2">
                <Form.Group as={Col} md="6" controlId="validationCustom01">
                    <Form.Label style={{ marginBottom: 0 }} >Full Name</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="Full Name"
                        defaultValue={displayName}
                        disabled
                    />
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="validationCustom02">
                    <Form.Label style={{ marginBottom: 0 }} >Address</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="Address"
                        defaultValue={applicant1Address}
                        disabled
                    />
                </Form.Group>
            </Row>
            <Row className="mb-2">
                <Form.Group as={Col} md="6" controlId="validationCustom03">
                    <Form.Label style={{ marginBottom: 0 }}>Telephone No.</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="Telephone No."
                        defaultValue={applicant1PhoneNo}
                        disabled
                    />
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="validationCustom04">
                    <Form.Label style={{ marginBottom: 0 }}> Miners Right No.</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="Miners Right No."
                        defaultValue={applicant1MinersRightNo}
                        disabled
                    />
                </Form.Group>
            </Row>

            {extraApplicants.map((applicant, index) => {

                return <>
                    <Row className="mb-1">

                        <Col style={{ textAlign: 'center' }}>
                            <strong style={{ marginRight: 4 }}>
                                Applicant {index + 2}
                            </strong>
                            <button style={{ fontSize: 14 }} onClick={e => { e.preventDefault(); removeApplicant(applicant.id); }} className='btn btn-danger btn-sm '>
                                <FontAwesomeIcon icon={faMinus} />
                            </button>
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Form.Group as={Col} md="6" controlId={"validationCustomFullName" + applicant.id}>
                            <Form.Label style={{ marginBottom: 0 }} >Full Name</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                placeholder="Full Name"
                                defaultValue={applicant.fullName}
                                onChange={(e) => { setApplicantFullName(applicant.id, e.target.value) }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="6" controlId={"validationCustomAddress" + applicant.id}>
                            <Form.Label style={{ marginBottom: 0 }} >Address</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                placeholder="Address"
                                defaultValue={applicant.address}
                                onChange={(e) => { setApplicantAddress(applicant.id, e.target.value) }}
                            />
                        </Form.Group>
                    </Row>
                    <Row className="mb-2">
                        <Form.Group as={Col} md="6" controlId={"validationCustomTelephone" + applicant.id}>
                            <Form.Label style={{ marginBottom: 0 }}>Telephone No.</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                placeholder="Telephone No."
                                defaultValue={applicant.phoneNumber}
                                onChange={(e) => { setApplicantPhoneNumber(applicant.id, e.target.value) }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="6" controlId={"validationCustomMinersRight" + applicant.id}>
                            <Form.Label style={{ marginBottom: 0 }}> Miners Right No.</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                placeholder="Miners Right No."
                                defaultValue={applicant.minersRightNo}
                                onChange={(e) => { setApplicantMinersRightNo(applicant.id, e.target.value) }}
                            />
                        </Form.Group>
                    </Row>
                </>
            })}
            <Row>
                <Col style={{ textAlign: 'center' }}>                    {
                    extraApplicants.length < 2 && <button onClick={(e) => {
                        e.preventDefault();
                        addApplicant();
                    }} className='btn btn-success btn-sm '>
                        <i className='fa fa-solid fa-plus' style={{ marginRight: 5 }}></i>
                        Add Applicant
                    </button>
                }

                </Col>
            </Row>

            <Row>
                <Col>
                    <h6>Vehicles (Max 10)</h6>
                </Col>
            </Row>
            {vehicles.map(vehicle => {
                return <Row className='mb-2'>
                    <Col xs={1}>
                    </Col>
                    <Col xs={1}>
                        <button style={{ fontSize: 14 }} onClick={e => { e.preventDefault(); removeVehicle(vehicle.id); }} className='btn btn-danger btn-sm '>
                            <FontAwesomeIcon icon={faMinus} />
                        </button>
                    </Col>
                    <Form.Group as={Col} md="3" controlId={"validationCustomVeichleMake" + vehicle.id}>
                        <Form.Control
                            style={{ fontSize: 14 }}
                            required
                            type="text"
                            defaultValue={vehicle.make}
                            onChange={e => { setVehicleMake(vehicle.id, e.target.value) }}
                            placeholder="Vehicle Make (i.e. Toyota)"
                        />
                    </Form.Group>
                    <Form.Group as={Col} md="3" controlId={"validationCustomVehicleModel" + vehicle.id}>
                        <Form.Control
                            style={{ fontSize: 14 }}
                            required
                            type="text"
                            defaultValue={vehicle.model}
                            onChange={e => { setVehicleModel(vehicle.id, e.target.value) }}
                            placeholder="Vehicle Model (i.e. Landcruiser)"
                        />
                    </Form.Group>
                    <Form.Group as={Col} md="3" controlId={"validationCustomVehicleRego" + vehicle.id}>
                        <Form.Control
                            style={{ fontSize: 14 }}
                            required
                            type="text"
                            defaultValue={vehicle.rego}
                            onChange={e => { setVehicleRego(vehicle.id, e.target.value) }}
                            placeholder="Vehicle Rego (i.e. ABC-123)"
                        />
                    </Form.Group>

                    {/*}

                    <Col>

                        <input style={{ fontSize: 14 }} required={true} type="text" defaultValue={vehicle.make}
                            onChange={e => { setVehicleMake(vehicle.id, e.target.value) }}
                            class={`form-control`}
                            id={"vehicleMake" + vehicle.id}
                            name={"vehicleMake" + vehicle.id}
                            placeholder="Vehicle Make (i.e. Toyota)" />
                        <div id={"vehicleMake" + vehicle.id} class="invalid-feedback">
                            Field Required
                        </div>
                    </Col>
                    <Col>
                        <input style={{ fontSize: 14 }} required={true} type="text" name="vehicleModel" defaultValue={vehicle.model} onChange={e => { setVehicleModel(vehicle.id, e.target.value) }} class="form-control" id={"vehicleModel" + vehicle.id} placeholder="Vehicle Model (i.e. Landcruiser)" />
                    </Col>
                    <Col>
                        <input style={{ fontSize: 14 }} required={true} type="text" name="vehicleRego" defaultValue={vehicle.rego} onChange={e => { setVehicleRego(vehicle.id, e.target.value) }} class="form-control" id={"vehicleRego" + vehicle.id} placeholder="Vehicle Rego (i.e. ABC-123)" />
                    </Col>
                    
                    */}
                </Row>

            })}
            <Row className='mb-2'>
                <Col xs={1}>
                </Col>
                <Col>
                    {
                        vehicles.length < 10 && <button onClick={(e) => {
                            e.preventDefault();
                            addVehicleEntry();
                        }} className='btn btn-success btn-sm '>
                            <i className='fa fa-solid fa-plus'></i>
                        </button>
                    }

                </Col>

            </Row>
        </Form>
    </Container >

}